import IBaseListingResponse from "../../utils/api/base-listing-response";
import {IDonationService, IDonationServiceDetails} from "../../models/donation-service/response";
import {IDonationServiceQuery} from "../../models/donation-service/query";
import {DEFAULT_FUNCTION, DEFAULT_QUERY} from "../../utils/helpers/constants";
import {ICreateDonationService, IUpdateDonationService} from "../../models/donation-service/request";
import {createContext} from "react";

export type DonationServiceLoading =
    | "list"
    | "details"
    | "create"
    | "update"
    | "delete";

export interface IInternalState {
  loading: DonationServiceLoading[];
  list?: IBaseListingResponse<IDonationService>;
  query: IDonationServiceQuery;
  details?: IDonationServiceDetails;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: IDonationServiceDetails) => void;
    createDonationService: (request: ICreateDonationService) => void;
    updateDonationService: (id: number, request: IUpdateDonationService) => void;
    deleteDonationService: (id: number) => void;
    setSearch: (search?: string) => void;
    setQuery: (query: IDonationServiceQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    createDonationService: DEFAULT_FUNCTION,
    updateDonationService: DEFAULT_FUNCTION,
    deleteDonationService: DEFAULT_FUNCTION,
    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const DonationServiceContext = createContext(externalState);

export default DonationServiceContext;